jQuery($ => {
    $(document).on('click', '.a-alert__close', event => {
        $(event.currentTarget).closest('.a-alert').remove();
    });
});
